import { useDispatch } from 'react-redux';
import {
  setResourcePanelView,
  useResourcePanelView,
  useBreadCrumbs,
  type ResourcePanelView,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import styles from './BreadCrumbs.module.css';
import { PanelCloseButton } from './PanelCloseButton';
import { QueueCategoryToggleButton } from './QueueCategoryToggleButton';

const CRUMB_LABELS = new Map<ResourcePanelView, string>([
  ['list_requests', 'Resources'],
  ['new', 'New Request'],
  ['air_ambulance', 'Air Ambulance'],
]);

function BreadCrumbs() {
  const dispatch = useDispatch();
  const currentView = useResourcePanelView();
  const crumbs = useBreadCrumbs();

  const handleCrumbClick = (view: ResourcePanelView) => {
    if (view !== currentView) {
      dispatch(setResourcePanelView(view));
    }
  };

  return (
    <nav className={styles.breadCrumbContainer}>
      {crumbs.length > 0 &&
        crumbs.map((crumb, index) => {
          const isActive = crumb === currentView;

          return (
            <span className={styles.breadCrumb} key={crumb}>
              {index > 0 && <span className="bread-crumb-separator">/</span>}
              <button
                className={`${isActive ? styles.active : ''} ${styles.breadCrumbButton}`}
                onClick={() => handleCrumbClick(crumb)}
                aria-current={isActive ? 'page' : undefined}
              >
                {CRUMB_LABELS.get(crumb)}
              </button>
            </span>
          );
        })}
      {currentView === 'air_ambulance' && <QueueCategoryToggleButton />}
      <PanelCloseButton pushRight={currentView !== 'air_ambulance'} />
    </nav>
  );
}

export default BreadCrumbs;
